// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","portrait":"only screen and (orientation: portrait)","landscape":"only screen and (orientation: landscape)","header":"header-3Rpoa","headerTitle":"headerTitle-2simc","headerByline":"headerByline-2S20q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/yearInReview/2018/midyear/Header/_mid2018Header.css
// module id = 1295
// module chunks = 1